(function (jedeye) {
    "use strict";
    jedeye(window.jQuery, window, document);
}(function ($, window, document) {

    // Contains all methods added for the requested for the current page instance
    window.JedeyeInstance = {};

    $(window).on('ajaxUpdateComplete', function (event, context, data) {

        /**
         * Trigger custom alerts.
         */
        if (data.hasOwnProperty('alert')) {
            $(document).trigger("jedeye.showModalPopup", [data.alert.message, data.alert.title, data.alert.subtitle, data.alert.iconClass]);
        }

        // Manages modal triggering or dismissing from the server side responses
        if (data.hasOwnProperty('triggerModal')) {
            $(data.triggerModal).modal('show');
        } else {
            if (data.hasOwnProperty('dismissModal')) {
                $(data.dismissModal).modal('hide');
            }
        }

        /**
         * Handle specific AJAX responses.
         */
        if (context.hasOwnProperty('handler')) {
            if (context.handler == 'reservation::onExtraItemUpdate') {

                $('[data-toggle="popover"]:not([data-event-attached])').each(function () {
                    $(this).popover({
                        placement: 'auto'
                    });
                    $(this).attr('data-event-attached', '');
                });
            }

            if (context.handler == 'reservation::onPackItemToggle') {

                $('.extras-table:first').each(function () {
                    var $table = $(this);
                    var $buttonContainers = $('tfoot .btn-container', $table);
                    $buttonContainers.eq(data._index).each(function () {
                        var index = $(this).index();
                        $('td, th', $table).removeClass('active');
                        if (data._action == 'add') {
                            $('tr', $table).each(function () {
                                $(this).children().eq(index).addClass('active');
                            });
                            $buttonContainers.not(':eq(' + data._index + ')').find('button').prop('disabled', false);
                            if ($buttonContainers.eq(data._index).hasClass('free-item')) {
                                $('button', $(this)).prop('disabled', true);
                            }
                        } else if (data._action == 'remove') {
                            $buttonContainers.find('button').prop('disabled', false);
                            // Activate a free item if available
                            var $freeItem = $table.find('td.free-item:first');
                            if ($freeItem.length) {
                                $('tr', $table).each(function () {
                                    $(this).children().eq($freeItem.index()).addClass('active');
                                });
                                $freeItem.find('button').prop('disabled', true);
                            }

                        }
                    });
                });
            }
        }
    });

    // Scrolls up on form validation error
    $('form[data-request]').on('ajaxError', function (event, obj, context, status) {
        var $el = $(this);
        setTimeout(function () {
            var $errorElems = $el.find('.has-error:first');
            if ($errorElems.length > 0) {
                $('html, body').animate({scrollTop: $errorElems.offset().top - 100}, 800);
            }
        }, 500);
    });

    // Enables form requests to be triggered by elements placed outside of it
    $('[data-request-target-elem]').on('click', function () {
        $($(this).data('request-target-elem')).submit();
    });

    /*************
     * Routed Functions
     */
    $(document).router({
        // Fleet pages
        dom_fleet: function () {
            "use strict";

            var setWrapperStyles = function (swiper) {
                var wrapperCenterClass = 'swiper-wrapper__center'
                var buttonDisabledClass = swiper.params.buttonDisabledClass
                var wrapperEl = swiper.wrapper[0]

                if (swiper.prevButton[0].classList.contains(buttonDisabledClass)
                    && swiper.nextButton[0].classList.contains(buttonDisabledClass)
                ) {
                    // center slides
                    wrapperEl.classList.add(wrapperCenterClass)
                } else {
                    wrapperEl.classList.remove(wrapperCenterClass)
                }
            }

            $(function () {
                // Multiple fleet swiper instances
                $(".fleet-swiper").each(function (index, element) {
                    var $this = $(this);
                    var swiper = new Swiper(this, {
                        slidesPerView: 5,
                        spaceBetween: 0,
                        grabCursor: true,
                        breakpoints: {
                            1600: {
                                slidesPerView: 4,
                                spaceBetween: 0
                            },
                            1250: {
                                slidesPerView: 3,
                                spaceBetween: 0
                            },
                            996: {
                                slidesPerView: 2,
                                spaceBetween: 0
                            },
                            700: {
                                slidesPerView: 1,
                                spaceBetween: 0
                            }
                        },
                        nextButton: $this.parent().find(".swiper-button-next")[0],
                        prevButton: $this.parent().find(".swiper-button-prev")[0],
                        onInit: function (swiper) {
                            setTimeout(function () {
                                setWrapperStyles(swiper)
                            }, 200)
                        },
                        onAfterResize: setWrapperStyles
                    });
                });
            });

        },

        dom_booking_step: function () {
            $(window).scroll(function () {
                var $elem = $('.header-attachment').eq(0);
                if ($(window).scrollTop() > ($elem.offset().top + $elem.outerHeight())) {
                    $('.header-attachment-placeholder').css('height', $('.header-attachment-sub').outerHeight());
                    $('.header-attachment-sub').addClass('fixed');
                } else {
                    $('.header-attachment-placeholder').css('height', 0);
                    $('.header-attachment-sub').removeClass('fixed');
                }
            });
        },

        dom_booking_step_4: function () {
            "use strict";
            $(function () {
                var slideSpeed = 500;

                $('.form-sub-container .show-btn').on("click", function (e) {
                    e.preventDefault();
                    var $el = $(this).closest('.form-sub-container');
                    $el.find('.section-body-container').slideDown(slideSpeed);
                    $el.removeClass('body-container-hidden');
                    $el.find('.section-enabled-flag').val('1');
                });

                $('.form-sub-container .hide-btn').on("click", function (e) {
                    e.preventDefault();
                    var $el = $(this).closest('.form-sub-container');
                    $el.find('.section-body-container').slideUp(slideSpeed);
                    $el.addClass('body-container-hidden');
                    $el.find('.section-enabled-flag').val('0');
                });

                $('#sameCustomerAsDriverNo').on("change", function () {
                    $('#customerMandatoryInfo').slideDown(slideSpeed, function () {
                        $('#customerOptionalInfo').slideDown(slideSpeed / 2);
                    });
                });

                $('#sameCustomerAsDriverYes').on("change", function () {
                    $('#customerOptionalInfo').slideUp(slideSpeed / 2, function () {
                        $('#customerMandatoryInfo').slideUp(slideSpeed / 2);
                    });
                });
            });

            $('input[data-datable]').datable();

            $(function () {
                $("#driver_date_of_birth").each(function () {
                    var $self = $(this);
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "name": $self.data('field-name'),
                        "minAge": 18,
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });
                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });

                $(".select-date-picker").each(function () {
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "minAge": 0,
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });

                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });
            });
        },

        dom_booking_step_5: function () {
            "use strict";
            $(function () {
                $('.round-radio-block').on("click", function () {
                    $(this).parents('.section-body-container:first').find('.round-radio-block').removeClass('active');
                    $(this).find('input[type=radio]').prop("checked", true);
                    $(this).addClass('active');
                });
            });
        },

        dom_sticky_sidebar: function () {
            var sidebar = document.getElementById('sidebar');
            $(sidebar).stickySidebar({
                topSpacing: -40,
                bottomSpacing: 20,
                containerSelector: '.main-content',
                innerWrapperSelector: '.sidebar__inner',
                minWidth: 992,
                resizeSensor: true
            });
            sidebar.addEventListener('affix.static.stickySidebar', function () {
                $(sidebar).removeClass('bs-affix-fix');
            });
            sidebar.addEventListener('affix.container-bottom.stickySidebar', function () {
                $(sidebar).removeClass('bs-affix-fix');
            });
            sidebar.addEventListener('affix.unbottom.stickySidebar', function () {
                $(sidebar).removeClass('bs-affix-fix');
            });
            sidebar.addEventListener('affix.top.stickySidebar', function () {
                $(sidebar).addClass('bs-affix-fix');
            });
            sidebar.addEventListener('affix.bottom.stickySidebar', function () {
                $(sidebar).addClass('bs-affix-fix');
            });
        },

        dom_show_more_items: function ($targetEl) {
            $('.show-more-items-btn', $targetEl).on("click", function (e) {
                e.preventDefault();
                var $el = $(this),
                    $parent = $(this).parents('.extras-rows-container:first');
                $parent.find('.row.hide:eq(0)').hide().removeClass('hide').slideDown(600, function () {
                    if ($parent.find('.row.hide').length == 0) {
                        $el.animate({
                            'opacity': 0
                        }, 500, function () {
                            $(this).css('visibility', 'hidden');
                        });
                    }
                });

            });

        },

        dom_popovers: function () {

            $(function () {
                "use strict";

                $('[data-toggle="popover"]:not([data-event-attached])').each(function () {
                    $(this).popover({
                        placement: 'auto'
                    });
                    $(this).attr('data-event-attached', '');
                });

            });
        },

        dom_tooltips: function () {
            $(function () {
                "use strict";
                $('[data-toggle="tooltip"]').tooltip();
            });
        },

        // SVG Supported Pages
        dom_svg: function () {
            /*
             * Replace all SVG images with inline SVG (only for .icon classes)
             */
            $('img[src$=".svg"].icon').each(function () {
                var $img = jQuery(this);
                var imgURL = $img.attr('src');
                var attributes = $img.prop("attributes");

                $.get(imgURL, function (data) {
                    // Get the SVG tag, ignore the rest
                    var $svg = jQuery(data).find('svg');

                    // Remove any invalid XML tags
                    $svg = $svg.removeAttr('xmlns:a');

                    // Loop through IMG attributes and apply on SVG
                    $.each(attributes, function () {
                        $svg.attr(this.name, this.value);
                    });

                    // Replace IMG with SVG
                    $img.replaceWith($svg);
                }, 'xml');
            });
        },
        // SVG Supported Pages
        dom_svg_all: function () {
            /*
             * Replace all SVG images with inline SVG
             */
            $('img[src$=".svg"]').each(function () {
                var $img = jQuery(this);
                var imgURL = $img.attr('src');
                var attributes = $img.prop("attributes");

                $.get(imgURL, function (data) {
                    // Get the SVG tag, ignore the rest
                    var $svg = jQuery(data).find('svg');

                    // Remove any invalid XML tags
                    $svg = $svg.removeAttr('xmlns:a');

                    // Loop through IMG attributes and apply on SVG
                    $.each(attributes, function () {
                        $svg.attr(this.name, this.value);
                    });

                    // Replace IMG with SVG
                    $img.replaceWith($svg);
                }, 'xml');
            });
        },

        dom_colorize: function () {

            function hexToRgb(hex) {
                var c;
                if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                    c = hex.substring(1).split('');
                    if (c.length == 3) {
                        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c = '0x' + c.join('');
                    return {r: (c >> 16) & 255, g: (c >> 8) & 255, b: c & 255};
                }
                throw new Error('Bad Hex');
            }

            $('img[data-colorize-color]').each(function (index) {

                var colorizedDataKey = $(this).data('colorize-id') + $(this).data('colorize-color'),
                    colorizedDataUrl = localStorage[colorizedDataKey] || null;

                if (colorizedDataUrl !== null) {
                    $(this).attr('src', colorizedDataUrl);
                    return;
                }

                var $originalEl = $(this),
                    $copyEl = $('<img/>');

                $copyEl.attr('class', $originalEl.attr("class"));
                $copyEl.addClass('jedeye-colorized-' + index);
                $originalEl.after($copyEl);
                $originalEl.hide();

                var image = new Image();
                image.onload = function () {
                    var $canvas = $('<canvas width="' + image.width + '" height="' + image.height + '"></canvas>'),
                        canvas = $canvas[0],
                        ctx = canvas.getContext("2d");

                    ctx.drawImage(image, 0, 0);

                    var imgd = ctx.getImageData(0, 0, image.width, image.height),
                        pix = imgd.data,
                        colorComponents = hexToRgb($originalEl.data('colorize-color')),
                        uniqueColor = [colorComponents.r, colorComponents.g, colorComponents.b]; // Blue for an example, can change this value to be anything.

                    // Loops through all of the pixels and modifies the components.
                    for (var i = 0, n = pix.length; i < n; i += 4) {
                        pix[i] = uniqueColor[0];   // Red component
                        pix[i + 1] = uniqueColor[1]; // Blue component
                        pix[i + 2] = uniqueColor[2]; // Green component
                        //pix[i+3] is the transparency.
                    }

                    ctx.putImageData(imgd, 0, 0);

                    var savedImageData = $('.jedeye-colorized-' + index)[0];
                    savedImageData.src = canvas.toDataURL("image/png");
                    $.post($('html').data('root') + '/customtheme/setimage', {
                        imgData: savedImageData.src,
                        imgColor: $originalEl.data('colorize-color'),
                        imgId: $originalEl.data('colorize-id')
                    });
                    localStorage[colorizedDataKey]
                    $copyEl.attr('id', $originalEl.attr("id"));
                    $originalEl.remove();
                };

                image.src = $(this).attr('src');

            });
        },

        dom_sticky_header: function () {
            var $header = $('.header-box.main');
            $(document).on("scroll", function (e) {
                if ($(document).scrollTop() > $header.offset().top + $header.outerHeight()) {
                    $('body').addClass("fix-header");
                } else {
                    $('body').removeClass("fix-header");
                }
            });
            // $('.header-box').affix({
            //     offset: {
            //         top: $('.top-section').outerHeight(true)
            //     }
            // }).on('affix.bs.affix', function () {
            //     $(this).find('.inner-logo').removeClass('animated zoomOut').addClass('animated zoomIn').show();
            //     $(this).addClass('small');
            //     $('.header-box--affix-placeholder').show().animate({
            //         height: '100px'
            //     }, 400);
            // }).on('affix-top.bs.affix', function () {
            //     $(this).find('.inner-logo').removeClass('animated zoomIn').addClass('animated zoomOut');
            //     $(this).removeClass('small');
            //     $('.header-box--affix-placeholder').hide().css('height', $('.header-box--affix-placeholder').data('height') + 'px');
            // }).each(function () {
            //     $('.header-box--affix-placeholder').css('height', $(this).outerHeight(true) + 'px').data('height', $(this).outerHeight(true));
            // });
        },

        dom_group_info: function () {
            window._showGroupInfo = function (triggerEL) {
                var groupId = $(triggerEL).data('id'),
                    $modal = $('#fgmodal-' + groupId);
                $modal.modal({
                    backdrop: true
                });
                $modal.modal('show');
                $modal.find('.fg-booking-btn').off('click').on('click', function () {
                    $modal.modal('hide').data('bs.modal', null);
                    setTimeout(function () {
                        $('button[data-group-id=' + groupId + ']').trigger('click')
                    }, 500)
                });

                var $swiperEl = $('.swiper-container', '#fgmodal-' + groupId);
                if (!$swiperEl.hasClass('swiper-loaded')) {
                    var swiper = new Swiper($swiperEl[0], {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        autoplay: 5000,
                        grabCursor: true,
                        pagination: '#fgmodal-' + groupId + ' .swiper-pagination',
                        paginationClickable: true
                    });
                }

                $swiperEl.addClass('swiper-loaded');
            };

            // Stop href="#hashtarget" links jumping around the page
            var hashLinks = document.querySelectorAll(".fg-tabs a[href^='#']");
            [].forEach.call(hashLinks, function (link) {
                link.addEventListener("click", function (event) {
                    event.preventDefault();
                    $(link).parent().find($(link).attr('href')).addClass('active').siblings('div').removeClass('active');
                    $(link).addClass('active').siblings('a').removeClass('active');
                });
            });
        },

        dom_stations_maps: function () {

            var nl2br = function (str, is_xhtml) {
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            $(function () {

                var reloadMapProperties = function (mapInstance, stationElem) {
                    mapInstance.removeMarkers();
                    mapInstance.addMarker({
                        lat: parseFloat(stationElem.data('lat')),
                        lng: parseFloat(stationElem.data('lng')),
                        title: stationElem.data('title'),
                    });
                    mapInstance.setCenter(stationElem.data('lat'), stationElem.data('lng'));
                    mapInstance.refresh();
                };

                $('.station-info').each(function () {
                    var $stationPopup = $(this),
                        $stationElem = $('.station-info-data', $stationPopup),
                        defaultIcon = $('.pre-icon', $stationPopup).data('default-img');

                    if ($stationElem.length > 0) {

                        $('.contact-us-btn', $stationElem).on('click', function () {
                            if ($(this).data('target-url')) {
                                window.location = $(this).data('target-url');
                            } else {
                                $('html, body').animate({scrollTop: $('form:first').length > 0 ? $('form:first').parent().offset().top - 100 : 0}, 800, function () {
                                    $('form:first input:first').trigger('focus');
                                });
                            }
                        });

                        $('.stations-list .btn-trigger').off("click").on("click", function () {
                            // Load data
                            var $dataEl = $(this).closest('li'),
                                data = $dataEl.data('info'),
                                name = $dataEl.data('name'),
                                group = $dataEl.data('group');

                            $('.st-title', $stationElem).html(data.title).parent().attr('style', !data.title ? 'display: none' : '');
                            $('.st-observations', $stationElem).html(data.observations).parent().attr('style', !data.title ? 'display: none' : '');
                            $('.st-address', $stationElem).html(data.address).parent().attr('style', !data.address ? 'display: none' : '');
                            $('.st-phone-1', $stationElem).html(data.phone_1).parent().attr('style', !data.phone_1 ? 'display: none' : '');
                            $('.st-phone-2', $stationElem).html(data.phone_2).parent().attr('style', !data.phone_2 ? 'display: none' : '');
                            $('.st-email', $stationElem).html(data.email).parent().attr('style', !data.email ? 'display: none' : '');
                            $('.st-schedule-open', $stationElem).html(data.working_days).parent().attr('style', !data.working_days ? 'display: none' : '');
                            $('.st-schedule-closed-inner', $stationElem).html(data.non_working_days).parent().attr('style', !data.non_working_days ? 'display: none' : '');

                            if ($dataEl.data('lat') != '' && $dataEl.data('lng') != '') {
                                $stationElem.data('lat', $dataEl.data('lat'));
                                $stationElem.data('lng', $dataEl.data('lng'));
                            } else {
                                $stationElem.data('lat', 0);
                                $stationElem.data('lng', 0);
                            }

                            $stationElem.data('title', name);

                            $stationPopup.removeClass('animate-in animate-out').addClass('animate-in').show();

                            var minSize = $('.top-side > div:eq(1)', $stationPopup).outerHeight();
                            if (minSize < 298) {
                                minSize = 298;
                            }
                            setTimeout(function () {
                                $('.top-side > div:eq(0)', $stationPopup).css('height', minSize + 'px');
                            }, 100);

                            // Update .station-info-data from server and then reload map properties
                            reloadMapProperties(map, $stationElem);
                            if ($stationPopup.data('loaded') != true) {
                                setTimeout(function () {
                                    reloadMapProperties(map, $stationElem);
                                    reloadMapProperties(map, $stationElem);
                                    $stationPopup.data('loaded', true);
                                }, 150);
                            }
                        });

                        var map = new GMaps({
                            div: '.map',
                            lat: 41.01369,
                            lng: -8.4093757,
                            enableNewStyle: true,
                            fullscreenControl: false,
                            zoom: 12
                        });

                        $(this).on('click', '.close-icon', function () {
                            $stationPopup.hide();
                        });
                    }
                });
            });
        },

        dom_custom_tabs: function () {
            $(".tab-menu a").click(function (e) {
                e.preventDefault();
                var $parent = $(this).closest('.tab-menu-container');

                var tab = $(this).attr("href");
                $(".tab-menu-content", $parent).not(tab).css("display", "none");
                $(tab).fadeIn();
                $(this).addClass("active");
                $(this).siblings().removeClass("active");
            });
        },

        dom_custom_select: function () {
            // Select2
            $(".custom-select").each(function () {
                var $el = $(this);
                $el.select2({
                    minimumResultsForSearch: -1,
                    placeholder: $el.data('placeholder') !== undefined ? $el.data('placeholder') : false
                })
            });
        },

        // Shared code
        common: function () {

            // Select2
            $(".custom-select").each(function () {
                var $el = $(this);
                $el.select2({
                    minimumResultsForSearch: -1,
                    placeholder: $el.data('placeholder') !== undefined ? $el.data('placeholder') : false
                })
            });

            function showModalPopup(message, title, subtitle, iconClass) {
                title = title || '';
                subtitle = subtitle || '';
                message = message || '';
                iconClass = iconClass || '';
                var $modal = $('#appModal:first');
                $('.m-title', $modal).html(title);
                $('.m-subtitle', $modal).html(subtitle);
                $('.m-message', $modal).html(message);
                // $('#appModalIcon', $modal).removeClass().addClass('icon').addClass(iconClass);
                $modal.modal('show');
            }

            $(document).on('jedeye.showModalPopup', function (event, message, title, subtitle, iconClass) {
                showModalPopup(message, title, subtitle, iconClass);
            });

            // code put inside the common property will be executed on all page loads
            function centerModal() {
                $(this).css('display', 'block');
                var $dialog = $(this).find(".modal-dialog"),
                    offset = ($(window).height() - $dialog.height()) / 2,
                    bottomMargin = parseInt($dialog.css('marginBottom'), 10);

                // Make sure you don't hide the top part of the modal w/ a negative margin if it's longer than the screen height, and keep the margin equal to the bottom margin of the modal
                if (offset < bottomMargin) offset = bottomMargin;
                $dialog.css("margin-top", offset);
            }

            $(document).on('show.bs.modal', '.modal', centerModal);
            $(window).on("resize", function () {
                $('.modal:visible').each(centerModal);
            });

            // Backdrop z-index fix
            // This solution uses a setTimeout because the .modal-backdrop isn't created when the event show.bs.modal is triggered.
            $(document).on('show.bs.modal', '.modal', function () {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function () {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });

            // Scrollbar fix
            // If you have a modal on your page that exceeds the browser height, then you can't scroll in it when closing an second modal.
            $(document).on('hidden.bs.modal', '.modal', function () {
                $('.modal:visible').length && $(document.body).addClass('modal-open');
            });

            $('.mobile-main-menu').sliiide({
                toggle: "#mobileMenuToggle", // the selector for the menu toggle, whatever clickable element you want to activate or deactivate the menu. A click listener will be added to this element.
                exit_selector: ".mobile-main-menu .close", // the selector for an exit button in the div if needed, when the exit element is clicked the menu will deactivate, suitable for an exit element inside the nav menu or the side bar
                animation_duration: "0.5s", //how long it takes to slide the menu
                place: "left", //where is the menu sliding from, possible options are (left | right | top | bottom)
                animation_curve: "cubic-bezier(0.54, 0.01, 0.57, 1.03)", //animation curve for the sliding animation
                body_slide: true, //set it to true if you want to use the effect where the entire page slides and not just the div
                no_scroll: true, //set to true if you want the scrolling disabled while the menu is active,
                onAnimationStart: function (obj, type) {
                    if (type == 'open') {
                        $("#mobileMenuToggle").animate({
                            opacity: 0
                        }, 50);
                        $(".mobile-main-menu .close").animate({
                            opacity: 1
                        }, 200);
                    } else {
                        $("#mobileMenuToggle").animate({
                            opacity: 1
                        }, 200);
                        $(".mobile-main-menu .close").animate({
                            opacity: 0
                        }, 200);
                    }
                },
                onAnimationEnd: function (obj, type) {
                    $('.mobile-main-menu').next('div').attr('style', null);
                }

            });

            /********************************************
             * Footer Alignement to Bottom
             */
            function footerAlign() {
                var $footer = $('footer:first');
                var docHeight = $(window).height();
                var footerHeight = $footer.outerHeight();
                var footerTop = $footer.position().top + footerHeight;

                if (footerTop < docHeight) {
                    $footer.css('margin-top', 0 + (docHeight - footerTop) + 'px');
                }
            }

            $(document).ready(function () {
                footerAlign();
            });
            $(window).resize(function () {
                footerAlign();
            });

            // Add bootstrap style to static page tables
            $('table', '.static-page').addClass('table');
        }
    }, true);

}));